import {ConfigObjectType, StateId, utils} from '@wallaby-ui/core';
import * as React from 'react';
import {useIntl} from 'react-intl';

import FilterNodeContainer from './FilterNodeContainer';
import styles from './FilterTree.less';
import PropertiesGroup from 'src/js/containers/document/components/PropertiesGroup';
import {FilterSchema} from 'src/js/model/filters_config';

interface OwnProps {
  caseType?: string | number;
  config: ConfigObjectType;
  searchServiceUrl: string;
  filterAndSearchStateId: StateId;
  filteringStateId: StateId;
  schema: FilterSchema;
}

type Props = OwnProps;

export const FilterTree: React.FC<Props> = (props) => {
  const {
    caseType,
    config,
    filterAndSearchStateId,
    filteringStateId,
    schema,
    searchServiceUrl,
  } = props;
  const intl = useIntl();

  return (
    <ul role='tree' className={styles.dlFilterTree} data-name={'filterWrapper'}>
      {schema.getResultGroups() &&
        schema.getResultGroups().map((filterGroup) => {
          // filter groups by view
          const filtersByView = filterGroup.getFiltersByView(caseType);
          // show only non-empty groups
          return filtersByView.length > 0 ? (
            <PropertiesGroup
              key={filterGroup.getId()}
              title={utils.TranslateUtils.translate(
                {id: filterGroup.getLabel()},
                intl
              )}
            >
              {filtersByView.map((filter) => (
                <FilterNodeContainer
                  key={filter.id}
                  config={config}
                  searchServiceUrl={searchServiceUrl}
                  filterAndSearchStateId={filterAndSearchStateId}
                  filteringStateId={filteringStateId}
                  node={schema.getFilter(filter.id)}
                  level={1}
                  schema={schema}
                />
              ))}
            </PropertiesGroup>
          ) : null;
        })}
    </ul>
  );
};

FilterTree.displayName = 'FilterTree';
